<template>
  <v-card class elevation="0">
    <v-card-text>
      <p class="display-1 text--primary">Setup MFA</p>

      <v-card
        v-if="!this.$store.state.didSetMfa || otpAuthString"
        elevation="3"
        class="my-5 mx-auto"
      >
        <v-card-text v-if="this.$store.state.didSetMfa">
          <div class="display-1 text--primary mx-auto">
            <QrCode v-if="MFAmode === 'QR'" :value="otpAuthString" />
            <p class="caption" v-else>
              Secret key:
              <br />
              <i>{{ secret }}</i>
              <br />
              <br />*Has to be manually entered into a MFA device
            </p>
          </div>
        </v-card-text>

        <v-card-text v-if="!this.$store.state.didSetMfa">
          <v-dialog v-model="dialog" persistent max-width="290">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" class="mx-5" :loading="creatingMFA" v-on="on">Generate MFA</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">Warning</v-card-title>
              <v-card-text>
                Generating a new MFA will override any existing MFA for this user,
                making any previous MFA obsolete.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialog = false">Cancel</v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="
                  () => {
                    dialog = false;
                    createMFA();
                  }
                "
                >Continue</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>

        <v-card-text>
          <v-btn
            v-if="this.$store.state.didSetMfa"
            color="secondary"
            class="mx-5"
            :loading="creatingMFA"
            @click="switchMFAMode"
          >
            <div v-if="MFAmode === 'QR'">Show secret key instead</div>
            <div v-else>Show QR code instead</div>
          </v-btn>
        </v-card-text>
      </v-card>
      <v-card v-else elevation="3" class="my-5 mx-auto d-flex flex-column justify-center">
        <v-card-text>
          <v-btn class="mx-5" disabled>
            <div>MFA Created</div>
          </v-btn>
        </v-card-text>
      </v-card>

      <div class="text--primary">
        <b>Steps:</b>
        <ul>
          <li>Download and install an MFA application to your mobile phone</li>
          <li>
            In the MFA application press the "add mfa" button, and pick the scan
            barcode option
          </li>
          <li>Press the "Generate MFA" button above</li>
        </ul>

        <ul>
          <li>Scan the QR Code with the application</li>
          <ul>
            <li>
              Or alternatively show the secret key instead, and manually enter
              it into the MFA app
            </li>
          </ul>
          <li>
            Now your device should be setup to generate MFA codes you can use to
            authenticate when logging in.
          </li>
        </ul>
        <br />
      </div>
      <br />
    </v-card-text>
  </v-card>
</template>

<script>
import Authentication from "../../auth";
import EventBus from "../../utility/Eventbus";
import QrCode from "../QrCode";
export default {
  name: "SetupMFA",
  components: {
    QrCode,
  },
  data() {
    return {
      dialog: false,
      MFAmode: "QR",
      creatingMFA: false,
      otpAuthString: undefined,
    };
  },
  computed: {
    secret: function () {
      return this.otpAuthString.split("=")[1].split("&")[0];
    },
  },
  methods: {
    switchMFAMode() {
      if (this.MFAmode === "QR") {
        this.MFAmode = "SECRET";
      } else {
        this.MFAmode = "QR";
      }
    },
    goTo(path) {
      this.$route.path !== path && this.$router.go(path);
    },
    async createMFA() {
      this.creatingMFA = true;

      const response = await Authentication.fetch(
        "api/radius/createmfa",
        "POST"
      );
      if (response && response.otpAuthString) {
        EventBus.$emit("snackbar", response.message);
        this.otpAuthString = response.otpAuthString;
        this.$store.commit("setDidChangeMfa", true);
      }

      this.$store.commit("setDidChangeMfa", true);
      // this.otpAuthString =
      //   "otpauth://totp/casper?secret=S74YWMKSVGY6XFEXJRPLO2GLZU&issuer=IkanoCloud";
      // console.log(this.otpAuthString);

      this.creatingMFA = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
